import { Component, OnInit } from '@angular/core';
import { SearchService } from 'src/services/search-service.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '@app/auth';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss'],
  providers: [MessageService],
})
export class WishlistComponent implements OnInit {
  whistlist: any = [];
  whistlistLocation: any;
  wishlistData: any = [];
  el: any;
  currentUser: any;
  whistlistItems: any = [];
  isLoading: boolean = true;
  //  wishListDeatils:any;
  constructor(
    private searchService: SearchService,
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.wishListDeatils();
  }
  wishListDeatils() {
    this.isLoading = true;
    this.whistlist = [];
    this.searchService.getWishList().subscribe((wishlistData) => {
      // wishlistData.forEach((element:any) => {
      this.wishlistData = wishlistData;
      this.titleService.setTitle(this.translate.instant('Wishlist') + ' ' + '| The Seychelles Islands');
      if (!wishlistData || wishlistData.length === 0) {
        this.isLoading = false;
        return;
      }
      Array.from(wishlistData).map((attData: any) => {
        this.searchService.getViewListingDetails(attData.field_product_id).subscribe((data) => {
          if (data) {
            if (data.attributes) {
              data.accredations = [];
              Array.from(data.attributes).map((attData: any) => {
                if (
                  attData.attributeTypeId === 'ACCREDITN' &&
                  (attData.attributeId === 'SSTL' || attData.attributeId === 'SSC')
                ) {
                  data.accredations.push('../../../assets/images/ssblue.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSBRONZE') {
                  data.accredations.push('../../../assets/images/ssbronze.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSGOLD') {
                  data.accredations.push('../../../assets/images/ssgold.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSLIVER') {
                  data.accredations.push('../../../assets/images/sssilver.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSILVER') {
                  data.accredations.push('../../../assets/images/sssilver.png');
                }
                // if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'UAA') {
                // data.accredations.push('../../../assets/images/home-slick-slider-3.jpg');
                // }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'TSCL') {
                  data.accredations.push('../../../assets/images/safe-label.jpg');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'WORKCATION') {
                  data.accredations.push('../../../assets/images/workcation.jpg');
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  data.starRating = -1;
                } else if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription != 'Ungraded') {
                  data.starRating = attData.attributeId;
                }
              });
            }
            if (data.productTypes) {
              data.classification = [];
              var language = localStorage.getItem('language');
              Array.from(data.productTypes).map((attData: any) => {
                if (attData.productTypeDescriptionMv && attData.productTypeDescriptionMv !== '' && language !== 'EN') {
                  attData.productTypeDescription = attData.productTypeDescriptionMv.replace('&amp;', '&');
                } else {
                  attData.productTypeDescription = attData.productTypeDescription.replace('&amp;', '&');
                }
                data.classification.push(attData.productTypeDescription);
              });
            }
            if (data.multimedia) {
              let img = data.multimedia[0].serverPath.split('&');
              img[1] = 'fit=crop&crop=faces&w=460';
              img[2] = 'h=600';
              data.productImage = img.join('&');
            }
            this.whistlist.push(data);
            this.isLoading = false;
          }
        });
      });
    });
    // this.whistlist=this.whistlistItems;
    // const productItem = wishlistData.map((productId: any) => `"${productId.field_product_id}"`).join(',');
    // this.wishlistData = wishlistData;
    // this.searchService.wishListDeatils(productItem).subscribe((data) => {
    //   this.whistlist = data.products;
    //   this.whistlist.forEach((el: any) => {
    //     if (el.productDescription.length > 30) {
    //       el.productDescription = el.productDescription.substr(0, 100) + '...';
    //     }
    //   });
    // });
    //});
  }

  removeWishList(productId: number) {
    const wishlist = this.wishlistData.find((product: any) => product.field_product_id == productId);
    if (wishlist) {
      this.searchService.removeWishListDeatils(wishlist.nid).subscribe((data) => {
        this.whistlist = this.whistlist.filter((product: any) => product.productId != productId);
        this.wishlistData = this.wishlistData.filter((product: any) => product.field_product_id != productId);
        this.messageService.add({
          key: 'remove-wishlist',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Wishlist-Remove-Successfull'),
        });
      });
    }
  }

  viewMoreDetils(productId: number) {
    let url = '/listingdetails/' + productId;
    window.open(url, 'target=_blank');
  }
  addToWhishList(item: any) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      const prodcut = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
      if (prodcut) {
        const wishlist = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
        if (wishlist) {
          this.searchService.removeWishListDeatils(wishlist.nid).subscribe(
            (data) => {
              // this.whistlist = this.whistlist.filter((product: any) => product.productId !== item.productId);
              item.color = '#bbbbbb';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Remove-Successfull'),
              });
              this.wishListDeatils();
            },
            (err) => {
              this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
            }
          );
        }
      } else {
        this.wishListDeatils();
        if (this.wishlistData.length >= 10) {
          this.messageService.add({
            key: 'add-wishlist',
            severity: 'info',
            summary: 'Info',
            detail: this.translate.instant('WhishList-Exceed-Message'),
          });
        } else {
          this.searchService.postWishList(item.productId, 'wishlist', []).subscribe((result: any) => {
            if (result) {
              item.color = '#00a7a6';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Add-Successfull'),
              });
              this.wishListDeatils();
            }
          });
        }
      }
    } else {
      this.messageService.add({
        key: 'add-wishlist',
        severity: 'info',
        summary: 'Info',
        detail: this.translate.instant('WhishList-Login-Alert'),
      });
    }
  }
}
